import { ShieldCheck } from 'lucide-react';

import { Badge, Link, Text, Tooltip } from '@components/primitives';

import { useAppQuery } from '@queries/app';
import { docsHref } from '@utils/docs';

import css from './styles.module.css';

function PciTooltip() {
  return (
    <div className={css.tooltip}>
      <Text size="sm" leading="md">
        Apps in PCI mode have additional security features and restrictions in
        place.{' '}
        <Link
          className={css.tooltipLink}
          href={docsHref('/compliance/pci-compliance#pci-restricted-apps')}
        >
          Learn more
        </Link>
      </Text>
    </div>
  );
}

export interface PciModeProps {
  teamUuid: string;
  appUuid: string;
}

export function PciMode({ teamUuid, appUuid }: PciModeProps) {
  const { data: app } = useAppQuery(teamUuid, appUuid);

  if (!app?.pciMode) return null;

  return (
    <Tooltip align="start" alignOffset={0} interactive content={<PciTooltip />}>
      <Badge className={css.badge} variant="outline">
        <ShieldCheck />
        <span className={css.label}>PCI Mode</span>
      </Badge>
    </Tooltip>
  );
}
